<template>
  <v-card class="overflow-hidden">
    <v-row class="ma-0 h-full">
      <!-- info -->
      <v-col
        cols="12"
        sm="12"
        md="9"
        lg="9"
        order="1"
        order-lg="1"
      >
        <v-card-title class="align-start">
          <!-- Номер и метка — одной строкой по центру друг друга, иначе значок
               «висел» выше номера. -->
          <div
            class="d-flex align-center flex-wrap"
            style="gap: 8px"
          >
            <span class="text-xl font-weight-semibold">
              {{ $t('Заявка') }} #{{ order.id }}
            </span>
            <!-- Клик по метке фильтрует список по этой группе; активная — закрашена. -->
            <v-chip
              v-if="isGroupOrder"
              color="#F4511E"
              :outlined="!isActiveGroup"
              :text-color="isActiveGroup ? 'white' : undefined"
              small
              style="cursor: pointer"
              :title="$t('Показать только эту группу')"
              @click="onGroupClick"
            >
              {{ groupNumber ? `${$t('ГРУППОВАЯ')} ${groupNumber}` : $t('ГРУППОВАЯ') }}
            </v-chip>
            <v-chip
              v-if="isSchoolOrder"
              color="#43A047"
              outlined
              small
              :title="$t('Школьная группа')"
            >
              {{ $t('ШКОЛЬНАЯ') }}
            </v-chip>
          </div>
          <v-spacer></v-spacer>
          <!-- На телефоне колонка статуса занимает всю ширину и переносится под
               номер: прижимаем её к левому краю, на планшете и шире — к правому. -->
          <div
            class="d-flex flex-column align-start align-sm-end pay-actions mt-2 mt-sm-0"
          >
            <span
              :class="'fix-state-width text-2xl font-weight-bold text-left text-sm-right ' + getOrderStatusColor(order.state, order.is_locked)"
            >
              {{ $t(getOrderStatusTitle(order.state)) }}
            </span>
            <v-btn
              v-if="showPay"
              outlined
              block
              class="mt-3 pl-4 pr-4"
              @click="toPayment(order)"
            >
              <v-icon
                small
                class="me-2"
              >
                {{ icons.mdiCreditCardWirelessOutline }}
              </v-icon>{{ $t('ОПЛАТА') }}
            </v-btn>
            <v-btn
              v-if="showPay"
              :color="isInCart ? 'primary' : 'default'"
              outlined
              block
              class="mt-2 pl-4 pr-4"
              @click="toggleCart"
            >
              <v-icon
                small
                class="me-2"
              >
                {{ isInCart ? icons.mdiCartCheck : icons.mdiCartOutline }}
              </v-icon>{{ isInCart ? `${$t('В корзине для оплаты')} (${cartCount})` : $t('Добавить в корзину') }}
            </v-btn>
          </div>
        </v-card-title>
        <v-card-title class="no-break text-2xl py-4">
          {{ objectInfo.museum['name' + getFormatedLocale()] }}
        </v-card-title>
        <v-card-subtitle class="no-break pt-2 pb-4">
          {{ objectInfo['name' + getFormatedLocale()] }}
        </v-card-subtitle>

        <div v-if="order.state == 2">
          <v-divider class="pb-2"></v-divider>
          <p class="mb-1 pt-1 px-4 order_status-accepted-green">
            {{ $t('Подтвержденное время:') }} {{ order.info.pass_time.substring(1) }}
          </p>
          <p class="pt-1 px-4 order_status-accepted-green">
            {{ $t('Вход:') }}
            {{ order.info.entrance_name }}
          </p>
          <!-- <v-card-subtitle class="no-break py-4 order_status-accepted-green"> -->
          <!-- </v-card-subtitle> -->
        </div>
        <v-divider class="pb-2"></v-divider>

        <v-card-actions class="d-flex justify-center pb-4">
          <v-row>
            <v-col
              cols="12"
              lg="4"
              md="4"
              sm="4"
              xs="12"
              class="py-2"
            >
              <p class="d-flex align-center mb-0">
                <v-icon color="secondary">
                  {{ icons.mdiCalendar }}
                </v-icon>
                <span class="no-break ms-3">{{ formatDate(order.data.pass_date) }}</span>
              </p>
            </v-col>
            <v-divider
              v-if="$vuetify.breakpoint.smAndUp"
              vertical
            >
            </v-divider>
            <v-col
              cols="12"
              lg="4"
              md="4"
              sm="4"
              xs="12"
              class="py-2"
            >
              <p class="d-flex align-center mb-0">
                <v-icon color="secondary">
                  {{ icons.mdiClockOutline }}
                </v-icon>
                <span class="ms-3">{{ order.info.museum_schedule_item }}</span>
              </p>
            </v-col>
            <v-divider
              v-if="$vuetify.breakpoint.smAndUp"
              vertical
            >
            </v-divider>
            <v-col
              cols="12"
              lg="4"
              md="4"
              sm="4"
              xs="12"
              class="py-2"
            >
              <p class="d-flex align-center mb-0">
                <v-icon color="secondary">
                  {{ icons.mdiAccountGroup }}
                </v-icon>
                <span class="ms-3">{{ getQtyTotal(order) }}</span>
              </p>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-col>
      <!-- actions -->
      <v-col
        cols="12"
        sm="12"
        md="3"
        lg="3"
        order="2"
        order-lg="2"
        class="memberpricing-bg"
      >
        <OrderActions
          :order="order"
          :object-info="objectInfo"
          :disabled-actions="disableActions"
          @refetch-upcoming="refetchUpcoming"
        ></OrderActions>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { formatDate } from '@/utils/filter'
import {
 getOrderStatusColor, getOrderStatusTitle, getQtyTotal, groupKeyOf, isGroupNotes, isSchoolNotes, refNoBase,
} from '@/utils/helper'
import { getCurrentInstance, computed } from '@vue/composition-api'
import { useRouter } from '@core/utils'
import store from '@/store'
// eslint-disable-next-line object-curly-newline
import OrderActions from '@/components/OrderActions.vue'
// eslint-disable-next-line object-curly-newline
import { mdiAccountGroup, mdiCalendar, mdiCartCheck, mdiCartOutline, mdiCheckboxMarked, mdiClockOutline, mdiCloseBox, mdiCreditCardWirelessOutline } from '@mdi/js'

export default {
  components: {
    OrderActions,
  },
  props: {
    order: {
      type: Object,
      required: true,
    },
    objectInfo: {
      type: Object,
      required: true,
    },
    disableActions: {
      type: Array,
      required: true,
    },

    // Активный фильтр группы со страницы «Заказы»: '' — выключен, 'ALL' — все
    // групповые, иначе ключ конкретной группы. По нему подсвечиваем метку.
    activeGroupKey: {
      type: String,
      required: false,
      default: '',
    },
  },
  setup(props, { emit }) {
    const vm = getCurrentInstance().proxy
    const { router } = useRouter()
    const refetchUpcoming = () => {
      vm.$parent.fetchUpcoming()
    }
    const toPayment = order => {
      // Сумму клиент вводит сам на странице оплаты; номер заявки подставляем в поле.
      router.push({ name: 'payment', query: { vouchers: order.id } }).catch(() => {})
    }

    // Кнопка «ОПЛАТА» — только на подтверждённых (state 2) незаблокированных заявках
    // и не там, где действие 'pay' отключено (архив).
    const showPay = computed(
      () => props.order.state === 2
        && props.order.is_locked !== 1
        && !props.disableActions.includes('pay'),
    )

    // Заявка, поданная в режиме «несколько музеев на одну группу»: узнаём по метке,
    // которую клиент ставит в примечание при отправке (единственный признак —
    // в системе заявок такие заявки ничем не связаны и ничем не отличаются).
    const isGroupOrder = computed(() => isGroupNotes(props.order.data && props.order.data.notes))

    // Школьная группа — тоже по пометке в примечании (12.10.2026).
    const isSchoolOrder = computed(() => isSchoolNotes(props.order.data && props.order.data.notes))

    // Ключ группы этой заявки и признак «сейчас отфильтровано по ней» (метка
    // закрашивается). Клик по метке просим родителя переключить фильтр.
    const groupKey = computed(() => groupKeyOf(props.order.data))

    // Номер группы из Ref# (12345-1 -> 12345). Показываем прямо на метке, чтобы
    // две группы одной фирмы было видно, не открывая «Подробнее».
    const groupNumber = computed(() => refNoBase(props.order.data && props.order.data.refno))
    const isActiveGroup = computed(() => {
      if (!props.activeGroupKey || !isGroupOrder.value) return false

      return props.activeGroupKey === 'ALL' || props.activeGroupKey === groupKey.value
    })
    const onGroupClick = () => emit('group-click', groupKey.value)

    // Кнопка «Добавить в корзину» (оплата нескольких заявок сразу).
    const isInCart = computed(() => store.getters['cart/isSelected'](props.order.id))

    // Сколько всего заявок в корзине — показываем числом в кнопке.
    const cartCount = computed(() => store.getters['cart/getCount'])

    const getFormatedLocale = () => {
        const locale = localStorage.getItem('locale') || 'ru'
        if (locale === 'zh') {
            return '_zh_cn'
        } if (locale === 'en') {
            return '_en_US'
        } if (locale === 'ru') {
            return '_ru_RU'
        } if (locale === 'fa') {
            return '_fa_IR'
        } if (locale === 'vi') {
            return '_vi'
        }

return '_ru_RU'
    }

    // В корзину кладём не только id, но и музей/дату — чтобы список в шапке был читаемым.
    const toggleCart = () => {
      store.commit('cart/toggle', {
        id: props.order.id,
        museum: props.objectInfo.museum[`name${getFormatedLocale()}`],
        object: props.objectInfo[`name${getFormatedLocale()}`],
        date: formatDate(props.order.data.pass_date),
      })
    }

    return {
      getQtyTotal,
      formatDate,
      getOrderStatusTitle,
      getOrderStatusColor,
      refetchUpcoming,
      getFormatedLocale,
      isActiveGroup,
      groupNumber,
      onGroupClick,
      toPayment,
      showPay,
      isGroupOrder,
      isSchoolOrder,
      isInCart,
      cartCount,
      toggleCart,
      icons: {
        mdiCalendar,
        mdiClockOutline,
        mdiAccountGroup,
        mdiCheckboxMarked,
        mdiCloseBox,
        mdiCreditCardWirelessOutline,
        mdiCartOutline,
        mdiCartCheck,
      },
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~@core/preset/preset/mixins.scss';

@include theme--child(decline-bg) using ($material) {
  background-color: rgba(251, 218, 220, 0.25);
}

// membership pricing
@include theme--child(accept-bg) using ($material) {
  background-color: rgba(247, 250, 240, 0.5);
}
@include theme--child(memberpricing-bg) using ($material) {
  background-color: rgba(map-deep-get($material, 'primary-shade'), map-deep-get($material, 'states', 'hover'));
}
.no-break {
  word-break: normal;
}
.fix-state-width {
  min-width: 190px;
}
// Колонка статуса + кнопки оплаты. Ширину фиксируем под самый длинный ярлык
// («В КОРЗИНЕ ДЛЯ ОПЛАТЫ (99)» ≈ 306px), иначе при добавлении в корзину текст
// кнопки меняется и колонка (а с ней и кнопка «ОПЛАТА») прыгает по ширине.
// max-width не даёт вылезти за карточку на узких экранах.
.pay-actions {
  width: 306px;
  max-width: 100%;
}
.order-status-new {
  color: #8a8d93;
}
.order_status-accepted-green {
  color: #82bb3d;
}
.order-status-accepted-blue {
  color: #33b4ff;
}
.order-status-waiting {
  color: #ffb400;
}
.order-status-decline {
  color: #ff4c51;
}
</style>
